import { InjectionToken } from '@angular/core';

export interface FeatureSHeaderTourReplay {
  /** Chave i18n; fallback em português no template se a chave faltar. */
  labelKey: string;
  replay: () => void;
}

export const FEATURE_S_HEADER_TOUR_REPLAY =
  new InjectionToken<FeatureSHeaderTourReplay>('FEATURE_S_HEADER_TOUR_REPLAY');
